import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import styles from './AppShell.module.css';

/**
 * The authenticated application frame: persistent sidebar on desktop, an
 * overlay drawer on tablet and below, and a sticky top bar carrying identity
 * and the theme control.
 */
export function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Any navigation closes the drawer; a route change with the drawer still
  // over the content is the classic mobile-nav bug.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  return (
    <div className={styles.shell}>
      <Sidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />

      {menuOpen ? (
        <button
          type="button"
          aria-label="Close navigation"
          className={styles.scrim}
          onClick={() => setMenuOpen(false)}
        />
      ) : null}

      <div className={styles.main}>
        <Topbar sidebarOpen={menuOpen} onOpenMenu={() => setMenuOpen(true)} />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
